/*
 * AutosTW — sold-out tail for collection pages.
 *
 * Why this exists: Shopify has no native "sort by availability". The tyres collection is
 * 3,603 sold out of 4,621 (77%), so any native sort buries in-stock stock. Instead the main
 * grid is pinned to filter.v.availability=1 (see snippets/atw-custom-css.liquid) and this
 * script renders the sold-out remainder underneath it, giving one continuous list ordered
 * in-stock first. Zero store-level changes: the live Caros theme is untouched.
 *
 * Sold-out cards are fetched with Shopify's Section Rendering API against the same section
 * the page already rendered, so cards, badges, prices and the compare toggle come back
 * identical to the main grid.
 */
(function () {
  var PAGE_SIZE_UNKNOWN = 1;
  /* The main grid uses infinite scroll. On an unfiltered collection that means ~1,018 in-stock
     tyres load before the tail is ever reached, so an intersection trigger alone never fires in
     practice. Below this many in-stock results — i.e. once a shopper has filtered to a size,
     which is the case where "in stock first, sold out after" actually matters — load the tail
     straight away. Above it, show the header with a button and let scrolling also trigger it. */
  var AUTO_LOAD_MAX_RESULTS = 96;

  var root = document.querySelector('[data-atw-soldout]');
  if (!root) return;

  var grid = root.querySelector('[data-atw-soldout-grid]');
  var moreBtn = root.querySelector('[data-atw-soldout-more]');
  var countEl = root.querySelector('[data-atw-soldout-count]');
  var showBtn = root.querySelector('[data-atw-soldout-show]');

  var page = 1;
  var lastPage = PAGE_SIZE_UNKNOWN;
  var loading = false;
  var loadedFor = null;
  var importedGrid = null;
  var observer = null;
  /* Bumped by reset(). A fetch captures the value at issue time and drops its response if the
     view has moved on since — otherwise a slow request for the previous filter lands in the
     cleared grid while loadedFor already claims the new view is loaded, and nothing recovers. */
  var requestSeq = 0;
  var inflight = null;

  function mainSectionId() {
    var list = document.querySelector('results-list[section-id]');
    return list ? list.getAttribute('section-id') : 'main';
  }

  /* The main grid is only pinned to in-stock when availability=1. If a shopper explicitly asked
     for something else (e.g. followed "view all sold out"), the tail would duplicate the grid. */
  function isInStockView() {
    return new URLSearchParams(location.search).get('filter.v.availability') === '1';
  }

  function sectionUrl(p) {
    var q = new URLSearchParams(location.search);
    q.set('filter.v.availability', '0');
    q.set('section_id', mainSectionId());
    if (p > 1) {
      q.set('page', String(p));
    } else {
      q.delete('page');
    }
    return location.pathname + '?' + q.toString();
  }

  function reset() {
    requestSeq++;
    if (inflight) {
      inflight.abort();
      inflight = null;
    }
    loading = false;
    page = 1;
    lastPage = PAGE_SIZE_UNKNOWN;
    loadedFor = null;
    importedGrid = null;
    grid.textContent = '';
    root.hidden = true;
    moreBtn.hidden = true;
    moreBtn.disabled = false;
    if (showBtn) showBtn.hidden = true;
  }

  /* Identity of the current view for caching purposes. `page` is excluded on purpose: infinite
     scroll rewrites it as the shopper scrolls the in-stock grid, and the sold-out set does not
     depend on which page of in-stock results is showing. Without this the tail would be wiped
     and refetched on every scroll step. */
  function viewKey() {
    var q = new URLSearchParams(location.search);
    q.delete('page');
    q.delete('preview_theme_id');
    var parts = [];
    q.forEach(function (v, k) { parts.push(k + '=' + v); });
    parts.sort();
    return location.pathname + '?' + parts.join('&');
  }

  /* In-stock result count for the current view, rendered by Horizon's filter block. */
  function inStockCount() {
    var el = document.querySelector('[data-results-count]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-results-count'), 10);
    return isNaN(n) ? null : n;
  }

  function fetchPage(p) {
    if (loading) return Promise.resolve();
    loading = true;
    moreBtn.disabled = true;

    var seq = requestSeq;
    var controller = 'AbortController' in window ? new AbortController() : null;
    inflight = controller;

    var options = { headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (controller) options.signal = controller.signal;

    return fetch(sectionUrl(p), options)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (seq !== requestSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedGrid = doc.querySelector('#ResultsList ul.product-grid');
        var items = fetchedGrid ? fetchedGrid.querySelectorAll(':scope > li') : [];

        if (!items.length) {
          if (p === 1) root.hidden = true;
          moreBtn.hidden = true;
          return;
        }

        if (p === 1) {
          /* Import the whole results wrapper, not just the <li>s: it carries the grid classes
             and the container-type inline style the card layout depends on. The id is dropped
             because #ResultsList already exists on the page. */
          var wrapper = doc.querySelector('#ResultsList');
          wrapper.removeAttribute('id');
          importedGrid = wrapper.querySelector('ul.product-grid');
          lastPage = parseInt(importedGrid.getAttribute('data-last-page') || '1', 10) || 1;

          var total = doc.querySelector('[data-results-count]');
          if (total && countEl) {
            countEl.textContent = total.getAttribute('data-results-count');
          }

          grid.appendChild(document.importNode(wrapper, true));
          importedGrid = grid.querySelector('ul.product-grid');
          root.hidden = false;
        } else {
          Array.prototype.forEach.call(items, function (li) {
            importedGrid.appendChild(document.importNode(li, true));
          });
        }

        page = p;
        moreBtn.hidden = page >= lastPage;
      })
      .catch(function () {
        /* An abort or a superseded response is not a failure — the newer request owns the UI. */
        if (seq !== requestSeq) return;
        /* A failed tail must never break the collection page — just stay hidden. */
        if (p === 1) root.hidden = true;
        moreBtn.hidden = true;
      })
      .then(function () {
        /* Only the request that still owns the view may release the guards; reset() has already
           cleared them for anything superseded. */
        if (seq !== requestSeq) return;
        loading = false;
        moreBtn.disabled = false;
        inflight = null;
      });
  }

  function start() {
    if (!isInStockView()) {
      reset();
      return;
    }
    var key = viewKey();
    if (loadedFor === key) return;
    reset();
    loadedFor = key;
    if (showBtn) showBtn.hidden = true;
    fetchPage(1);
  }

  /* Reveal the heading plus an explicit button, without fetching 24 cards worth of markup that
     a shopper browsing an unfiltered 4,600-product collection probably will not scroll to. */
  function offerButton() {
    if (!showBtn) return;
    root.hidden = false;
    showBtn.hidden = false;
  }

  function decide() {
    if (!isInStockView()) {
      reset();
      return;
    }
    var n = inStockCount();
    if (n === null || n <= AUTO_LOAD_MAX_RESULTS) {
      start();
    } else {
      offerButton();
      observe();
    }
  }

  /* Scrolling to the bottom of a long in-stock list is the other way in. */
  function observe() {
    if (observer) observer.disconnect();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) start();
      },
      { rootMargin: '600px 0px' }
    );
    observer.observe(root.parentElement || root);
  }

  if (showBtn) showBtn.addEventListener('click', start);

  moreBtn.addEventListener('click', function () {
    if (page < lastPage) fetchPage(page + 1);
  });

  /* Horizon re-renders the grid in place when filters change, without a page load. Watch the URL
     itself rather than Horizon internals so this keeps working across theme updates. */
  function watchUrl() {
    var last = viewKey();
    ['pushState', 'replaceState'].forEach(function (fn) {
      var original = history[fn];
      history[fn] = function () {
        var out = original.apply(this, arguments);
        window.dispatchEvent(new Event('atw:locationchange'));
        return out;
      };
    });
    window.addEventListener('popstate', function () {
      window.dispatchEvent(new Event('atw:locationchange'));
    });
    window.addEventListener('atw:locationchange', function () {
      var now = viewKey();
      if (now === last) return;
      last = now;
      reset();
      /* Filter changes are exactly when the result count drops into auto-load range. */
      setTimeout(decide, 250);
    });
  }

  watchUrl();
  decide();
})();
